<app-dialog [title]="data.title" [actions]="actions" (action)="close($event)" (close)="close()">
    <div class="sku_detail">
      <div class="sku_image">
        <img [src]="data.selectedSku.image" />
      </div>
      <div class="sku_detailRow">
        <div class="sku">
          <div class="sku_title">
            {{data.selectedSku.title}}
          </div>
          <div class="sku_chips">
            <app-sku-chip
            *ngIf="data.selectedSku.sku"
             [name]="'SKU'"
             [value]="data.selectedSku.sku"></app-sku-chip>
            <app-sku-chip
            *ngIf="data.selectedSku.asin"
            [name]="'Asin'"
            [value]="data.selectedSku.asin"></app-sku-chip>
            <app-sku-chip
            *ngIf="data.selectedSku.fnSku"
            [name]="'FnSku'"
            [value]="data.selectedSku.fnSku"></app-sku-chip>
          </div>
        </div>
        <div class="panel-detail">
          <span><span class="label">Brand</span> <br>{{currentCatalog?.brand || '-'}}</span>
          <span><span class="label">Color</span> <br> {{currentCatalog?.color || '-'}}</span>
          <span><span class="label">Size</span> <br> {{currentCatalog?.size || '-'}}</span>
          <span><span class="label">FBA offer</span> <br> {{currentCatalog?.fbaOffer || '-'}}</span>
          <span><span class="label">FBM offer</span> <br> {{currentCatalog?.fbmOffer || '-'}}</span>
          <span><span class="label">Current buy box</span> <br> {{currentPriceOffer?.currentBuyBox || '-'}}</span>
          <span><span class="label">Item rank</span> <br> {{currentCatalog?.rank || '-'}}</span>
        </div>
        <a class="sku_link" target="_blank" href="https://www.amazon.com//dp/{{ data.selectedSku.asin }}">View on amazon <i class="fal fa-external-link-square-alt"></i></a>
      </div>
    </div>
    <div >
    <form [formGroup]="form" class="calculation-box">
      <div class="input-container">
        <label for="" class="input-container_label custom_label">Item Cost</label>
        <div class="input-container_wrapper">
          <input type="number" class="input-container_input  input-container_input--number" formControlName="itemCost" min="1" />
          <span class="input-container_icon">
            <i class="fa fa-dollar-sign"></i>
          </span>
        </div>
      </div>
      <div class="input-container">
        <label for="" class="input-container_label">Profit {{form.get('option').value == 'markup' ? 'Markup' : form.get('option').value == 'margin' ? 'Margin' : 'Amount'}}</label>
        <div class="input-container_wrapper input-container_selection">
          <input type="number" class="input-container_input  input-container_input--number" formControlName="profitMarkUp" min="1" />
          <span class="input-container_icon">
            <i class="fa fa-percent"></i>
          </span>
            <mat-radio-group aria-label="Select an option" formControlName="option" class="label_selection">
              <mat-radio-button class="custom-mat-radio" value="markup">Markup</mat-radio-button>
              <mat-radio-button class="custom-mat-radio" value="margin">Margin</mat-radio-button>
              <mat-radio-button class="custom-mat-radio" value="amount">Amount</mat-radio-button>
            </mat-radio-group>
        </div>
      </div>
      <div class="calculation-toggle">
        <span>Use Live Claculations</span>
        <mat-slide-toggle class="ms-2"  [formControl]="useLiveCal"></mat-slide-toggle>
      </div>
      <app-button (click)="calculate()" [isDisabled]="loading || !form.valid">Calculate</app-button>
    </form>
    </div>
    <div class="calculation" *ngIf="showData && feeEstimate && !loading">
      <div class="calculation-result">
        <img class="calculation-result_img" src="../../../../../assets/images/amazon-icons/fba.svg" alt="">
        <div class="calculation-result_fee">
          <div class="calculation-result_fee--title">FBA Fees</div>
          <div class="calculation-result_fee--borderBox">
            <div class="fee-header">
              Picking
              <span>{{((!useLiveCal?.value ? feeEstimate.fbaPickAndPackFee : feeEstimate?.fbaFullfillmentFees) || 0) | currency}}</span>
            </div>
            <div class="fee-header">
              Shipping
              <span>{{(feeEstimate?.fbaPromotionFees || 0) | currency}}</span>
            </div>
            <div class="fee-header">
              Total FBA Fees
              <span>{{(feeEstimate?.fbaTotalFees || 0) | currency}}</span>
            </div>
          </div>
          <div class="fee-header p-0" *ngIf="feeEstimate?.fbaPromotionFees">
            Promotions
            <span>{{(feeEstimate?.fbaPromotionFees || 0) | currency}}</span>
          </div>
          <div class="fee-header p-0">
            Referral fee ({{ ((feeEstimate?.fbaReferralFee / feeEstimate?.minPrice.minPriceForFba) * 100) | number : '1.2-2'}}%)
            <span>{{(feeEstimate?.fbaReferralFee || 0) | currency}}</span>
          </div>
          <div class="calculation-result_footer">Total Fees: {{((feeEstimate?.fbaTotalFees + feeEstimate?.fbaReferralFee) || 0) | currency}}</div>
        </div>
        <div class="calculation-result_footer mt-auto mb-0">
          <div class="calculation-result_footer--title">
            Min price: {{(feeEstimate?.minPrice?.minPriceForFba || 0)| currency}}
            <div class="price">
              <div class="price_item price_item--fbm">
                <div class="price_amount">{{(data?.buyBoxPrice.fbaBbPrice || 0) | currency}}</div>
                <div class="price_buybox-type"></div>
              </div>
            </div>
          </div>
          <div class="calculation-result_footer--bottom">Break-even price : {{(feeEstimate?.breakEvenPrice?.breakEvenPriceForFba || 0) | currency}}</div>
        </div>
      </div>
  
      <div class="divider"></div>
  
      <div class="calculation-result" *ngIf="feeEstimate">
        <img class="calculation-result_img" src="../../../../../assets/images/amazon-icons/fbm.svg" alt="">
        <div class="calculation-result_fee">
          <div class="fee-header p-0">
            Referral fee ({{ ((feeEstimate?.fbmReferralFee / feeEstimate?.minPrice.minPriceForFbm) * 100) | number : '1.2-2'}}%)
            <span>{{(feeEstimate?.fbmReferralFee || 0) | currency}}</span>
          </div>
          <div class="calculation-result_footer fbm-footer">Total Fees: {{(feeEstimate?.fbmReferralFee || 0) | currency}}</div>
        </div>
        <div class="calculation-result_footer mt-auto mb-0 fbm-footer">
          <div class="calculation-result_footer--title">
            Min price: {{(feeEstimate?.minPrice.minPriceForFbm || 0 ) | currency}}
            <div class="price">
              <div class="price_item price_item--fbm">
                <div class="price_amount">{{(data.buyBoxPrice.fbmBbPrice || 0 ) | currency}}</div>
                <div class="price_buybox-type"></div>
              </div>
            </div>
          </div>
          <div class="calculation-result_footer--bottom">Break-even price : {{(feeEstimate?.breakEvenPrice?.breakEvenPriceForFbm || 0) | currency}}</div>
        </div>
      </div>
    </div>
    <div class="no-result" *ngIf="!showData && !loading">
      There is no data to show
    </div>
    <div class="loader" *ngIf="loading">
      <img [src]="'assets/images/nineyard-loading.gif'" />
    </div>
    <div class="calculation mt-2" *ngIf="showData && feeEstimate && !loading">
      <span class="text-center" [ngClass]="{'calculation_resultDetail' : data.selectedSku.fulfillmentType === 'FBM'}">
        <img src="../../../../../assets/images/loading.gif" class="me-1 text-loader" *ngIf="isLoadingSetMinPrice">
        <a class="underline pointer" (click)="savePrice()">Set min price to {{(feeEstimate?.minPrice?.minPriceForFba || 0) | currency}}</a>
      </span>
    </div>
  </app-dialog>